'use strict'

const DEFAULT_LANGUAGE = 'en-US'

const NON_BREAKING_SPACE = '\u00a0'

const DEFAULT_SYMBOL_POSITION = 'before'

const LANGUAGES = {
  en: { thousandSeparator: ',', decimalSeparator: '.', symbolPosition: 'before' },

  pt: { thousandSeparator: '.', decimalSeparator: ',', symbolPosition: 'before_with_space' },
  'pt-BR': { symbolPosition: 'before_with_space' },
  'pt-PT': { symbolPosition: 'after_with_space' },

  es: { thousandSeparator: '.', decimalSeparator: ',' },
  'es-US': { thousandSeparator: ',', decimalSeparator: '.', symbolPosition: 'before' },

  fr: { thousandSeparator: NON_BREAKING_SPACE, decimalSeparator: ',', symbolPosition: 'after_with_space' }
}

const CURRENCIES = {
  usd: { symbol: '$' },
  cad: { symbol: '$' },
  jpy: { symbol: '¥', zeroDecimal: true },
  eur: { symbol: '€' }
}

module.exports = {
  DEFAULT_LANGUAGE,
  DEFAULT_SYMBOL_POSITION,
  NON_BREAKING_SPACE,
  LANGUAGES,
  CURRENCIES
}
